var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "School-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 80,
            model: _vm.edit,
            elem: _vm.schoolElem,
            rules: _vm.schoolRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "学校名称", prop: "name" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入学校名称",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.edit,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "学校类型",
                            prop: "types",
                            required: true,
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.edit.types,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "types", $$v)
                                },
                                expression: "edit.types",
                              },
                            },
                            _vm._l(_vm.typeList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "最低年级", prop: "lowGradeId" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.lowGradeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "lowGradeId", $$v)
                                },
                                expression: "edit.lowGradeId",
                              },
                            },
                            _vm._l(_vm.gradesAll, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "最高年级", prop: "higtGradeId" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.higtGradeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "higtGradeId", $$v)
                                },
                                expression: "edit.higtGradeId",
                              },
                            },
                            _vm._l(_vm.gradesAll, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "其他年级", prop: "otherGradeIds" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { multiple: true },
                              model: {
                                value: _vm.edit.otherGradeIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "otherGradeIds", $$v)
                                },
                                expression: "edit.otherGradeIds",
                              },
                            },
                            _vm._l(_vm.gradesAll, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "联系人", prop: "contactPerson" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入联系人",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.contactPerson,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "contactPerson", $$v)
                              },
                              expression: "edit.contactPerson",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "联系电话", prop: "telphone" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入联系电话",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.telphone,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "telphone", $$v)
                              },
                              expression: "edit.telphone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "联系地址", prop: "address" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入联系地址",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.edit.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "address", $$v)
                              },
                              expression: "edit.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.enums.status, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                            },
                            model: {
                              value: _vm.edit.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remark", $$v)
                              },
                              expression: "edit.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }